import * as Yup from 'yup';
import { t } from '@lingui/macro';
import { ObjectSchema } from 'yup';
import { UpsertDimensionType, UpsertDimensionValueType, UpsertDistributionKeyType } from '~/app/shared/dimensions/api/types';
import { DimensionDistributionValue } from '~/app/shared/dimensions/types';

type SchemaFn<T extends object> = () => ObjectSchema<T>;

export const dimensionValidationSchema: SchemaFn<UpsertDimensionType> = () =>
    Yup.object().shape({
        name: Yup.string()
            .required()
            .test('whitespaces-check', t`Invalid name`, validateString),
        active: Yup.boolean().required(),
    });

export const dimensionValueValidationSchema: SchemaFn<UpsertDimensionValueType> = () =>
    Yup.object().shape({
        dimensionId: Yup.number().required(),
        key: Yup.number()
            .positive(t`Invalid number`)
            .max(2 ** 31 - 1, t`No. is too long`)
            .required(),
        name: Yup.string()
            .required()
            .test('whitespaces-check', t`Invalid name`, validateString),
        active: Yup.bool().required(),
    });

export const distributionKeyValidationSchema: SchemaFn<UpsertDistributionKeyType> = () =>
    Yup.object().shape({
        dimensionId: Yup.number().required(),
        key: Yup.number()
            .positive(t`Invalid number`)
            .max(2 ** 31 - 1, t`No. is too long`)
            .required(),
        name: Yup.string()
            .required()
            .test('whitespaces-check', t`Invalid name`, validateString),
        active: Yup.bool().required(),
        distributions: Yup.array()
            .of(distributionValueValidationSchema())
            .min(2, t`Distribution keys must have at least one value`)
            .required(),
    });

export const distributionValueValidationSchema: SchemaFn<DimensionDistributionValue> = () =>
    Yup.object().shape({
        dimensionValueKey: Yup.number()
            .nullable()
            .test('is-not-empty', t`Required`, value => typeof value !== 'undefined'),
        percent: Yup.number().when('dimensionValueKey', {
            is: (value: number | null) => value === null,
            then: Yup.number().test('positive-or-0-value', t`Invalid distribution value`, value => value >= 0 && value <= 100),
            otherwise: Yup.number().test('positive-value', t`Invalid distribution value`, value => value > 0 && value <= 100),
        }),
    });

const validateString = (value: string) => !!value && value.replace(/\s/g, '').length > 0;
